import dynamic from "next/dynamic";
import { FC } from "react";

const Skeleton = dynamic(
  async () => await (await import("shared/components/atoms/Skeleton")).Skeleton
);

interface Props {
  className?: string;
}

export const MenuTitle: FC<Props> = ({ children, className }) => {
  if (children) {
    return (
      <h1
        tw="font-base font-semibold text-lg leading-8 tracking-[.53px]"
        className={className}
      >
        {children}
      </h1>
    );
  } else {
    return <Skeleton tw="w-full h-7 rounded" className={className} />;
  }
};
